import { render } from "./device-details-information.vue?vue&type=template&id=1d30bddc&scoped=true&ts=true"
import script from "./device-details-information.ts?vue&type=script&lang=ts"
export * from "./device-details-information.ts?vue&type=script&lang=ts"

import "./device-details-information.scss?vue&type=style&index=0&id=1d30bddc&lang=scss&scoped=true"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d30bddc"]])

export default __exports__